import { copy } from '../data/website';
import { FadeIn } from './Reveal';

export const Statement = () => <section className="brand-statement company-statement" data-testid="statement-section">
  <FadeIn className="site-container company-statement-inner" y={16}>
    <p data-testid="hero-company-description">{copy.hero.company}</p>
    <p data-testid="hero-company-statement">{copy.hero.statement.replace('THEY EXPERIENCE.', '')}<em>THEY EXPERIENCE.</em></p>
  </FadeIn>
</section>;